import Model from "@/models/Model"

export default class AClose extends Model {
    resource() {
        return "close"
    }
}